import { IconButton, TableCell, TableRow } from '@material-ui/core'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import MoreIcon from '@material-ui/icons/MoreVert'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/BookingsListTableMobile.styles'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#a5a5a5',
      color: theme.palette.common.white
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow)

export const BookingsListTableRowMobileSkeleton = () => {
  const classes = useStyles()
  return (
    <StyledTableRow>
      <StyledTableCell>
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="left">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell className={classes.buttonContainer}>
        <IconButton className={classes.button}>
          <MoreIcon />
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  )
}
